import * as React from 'react';
import { Stack, CommandButton, PivotItem, Pivot } from '@fluentui/react';
import {
    MicIcon,
    MicOffIcon,
    CallVideoIcon,
    CallVideoOffIcon,
    CallEndIcon,
    CallControlPresentNewIcon,
    CallControlCloseTrayIcon,
    MoreIcon,
    SettingsIcon,
    QuestionCircleIcon,
    UserBlurIcon
} from '@fluentui/react-icons-northstar';
import {
    controlButtonStyle,
    endCallButtonStyle,
    endCallButtonTextStyle,
    mediaControlStyles,
    fullWidth,
    controlButtonDisabledStyle,
}
    from './styles/MediaControls.styles';
import { ParticipantStream } from 'core/reducers';
import { Constants } from 'core/constants';
import { ParticipantModel, ParticipantInfo, UpdateInterviewActivityLog } from 'Utils/participantInfo';
import { Label, MoreVert, MoreVertOutlined, MoreVertRounded, MoreVertTwoTone, Settings } from '@mui/icons-material';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { CommandPanelTypes } from './CommandPanel';
import { pivotItemStyle, pivotItemStylesInter } from './styles/Header.styles';
import { Badge } from 'reactstrap/lib';
import { commonPropTypes } from '@fluentui/react-northstar';
import { ShowHideBadge } from '../Utils/SignalRConnection';
import { blurEffectStart, blurEffectStop } from '../core/sideEffects';

export interface MediaControlsProps {
    micActive: boolean;
    screenShareActive: boolean;
    activeScreenShareStream: ParticipantStream | undefined;
    cameraActive: boolean;
    cameraPermission: string;
    microphonePermission: string;
    localVideoRendererIsBusy: boolean;
    compressedMode: boolean;
    onMicChange(): void;
    onCameraChange(): void;
    onScreenShareChange(): void;
    onEndCallClick(): void;
    isLocalScreenShareSupportedInBrowser(): boolean;
    screenWidth: number;
    selectedPane: CommandPanelTypes;
    setSelectedPane: any;
    //isScreenShareAllowed: boolean;
}

export default (props: MediaControlsProps): JSX.Element => {
    const modelone: ParticipantInfo = ParticipantModel();
    const cameraActive = props.cameraPermission === 'Denied' ? false : props.cameraActive;
    const cameraDisabled = props.cameraPermission === 'Denied';
    const cameraOnClick = props.cameraPermission !== 'Denied' ? props.onCameraChange : undefined;
    const micActive = props.microphonePermission === 'Denied' ? false : props.micActive;
    const micDisabled = props.microphonePermission === 'Denied';
    const micOnClick = props.microphonePermission !== 'Denied' ? props.onMicChange : undefined;
    const screenShareDisabled = !!props.activeScreenShareStream;
    const ScreenShareAllowed = modelone.isMobile == 'true' ? false : Constants.SCREENSHARE;
    const btnChat: HTMLDivElement | null = document.querySelector("#Chat");
    const closeButton: HTMLDivElement | null = document.querySelector("#closeButton");

    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);
    const getLeaveButtonName = () => {
        if (modelone != undefined) {
            if (modelone.role == "Interviewer")
                return "End Interview";
        }
        return "Leave Interview";
    }
    const handleToggle = () => {
        //const bannerDiv: HTMLDivElement | null = document.querySelector("#banner");
        //if (bannerDiv != null) {
        //    if (!open) 
        //        bannerDiv.style.position = "inherit";
        //    else
        //        bannerDiv.style.position = "absolute";
        //}
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: Event | React.SyntheticEvent) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }

        setOpen(false);
    };

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current!.focus();
        }

        prevOpen.current = open;
    }, [open]);

    const [ismicActive, setmicActive] = React.useState(false);
    React.useEffect(() => {
        console.log("ismicActive :: " + ismicActive);
        if (ismicActive) {
            let message = "";
            if (props.micActive) {
                message = "##UserRole# has their audio turned on during the interview.";
            } else {
                message = "##UserRole# has their audio turned off during the interview.";
            }
            UpdateInterviewActivityLog("Call", message);
        }
        setmicActive(true);
    }, [props.micActive]);

    const [iscameraActive, setcameraActive] = React.useState(false);
    React.useEffect(() => {
        console.log("iscameraActive :: " + iscameraActive);
        if (iscameraActive) {
            let message = "";
            if (props.cameraActive) {
                message = "##UserRole# switched on the camera during the interview.";
            } else {
                message = "##UserRole# switched off the camera during the interview.";
            }
            UpdateInterviewActivityLog("Call", message);
        }
        setcameraActive(true);
    }, [props.cameraActive]);

    const [isScreenShare, setScreenShare] = React.useState(false);
    React.useEffect(() => {
        if (isScreenShare) {
            let message = "";
            if (props.screenShareActive) {
                //message = "##UserRole# has begun screen share.";
                message = "##UserRole# has started a screen share during the interview.";
            } else {
                //message = "##UserRole# has ended screen share.";
                message = "##UserRole# has stopped the screen share during the interview.";
            }
            UpdateInterviewActivityLog("Screenshare", message);
        }
        setScreenShare(true);
    }, [props.screenShareActive]);

    const ShowHideChat = (selectedPane: string): void => {

        const divChat: HTMLDivElement | null = document.querySelector("#chatAndProDiv");
        const RightDiv: HTMLDivElement | null = document.querySelector("#RightDiv");
        //const btnChat: HTMLDivElement = document.querySelector("#Chat");
        if (divChat) {
            if (selectedPane == CommandPanelTypes.Chat) {

                if (modelone.isMobile == "true") {
                    const vdoGallery: HTMLDivElement | null = document.querySelector("#div1");
                    if (vdoGallery)
                        vdoGallery.style.display = "none";

                    const msOverlay: HTMLDivElement | null = document.querySelector(".ms-Overlay");
                    if (msOverlay)
                        msOverlay.style.display = "none";
                }

                btnChat?.classList.add('linkIsSelected-202');
                document?.getElementById("div1")?.classList.remove('col-md-3');
                document?.getElementById("div1")?.classList.remove('div1Padding');
                document?.getElementById("div1")?.classList.add('col-md-2');
                document?.getElementById("divCode")?.classList.remove('col-md-9');
                document?.getElementById("divCode")?.classList.add('col-md-7');
                document?.getElementById("divCode")?.classList.remove('divCodePadding');
                divChat.style.display = "block";

                if (RightDiv) {

                    RightDiv.style.display = "none";
                }

            }
            else {
                divChat.style.display = "none";
                if (RightDiv) {
                    RightDiv.style.display = "block";
                }

                if (modelone.isMobile == "true") {
                    const vdoGallery: HTMLDivElement | null = document.querySelector("#div1");
                    if (vdoGallery)
                        vdoGallery.style.display = "block";

                    const msOverlay: HTMLDivElement | null = document.querySelector(".ms-Overlay");
                    if (msOverlay)
                        msOverlay.style.display = "";

                }
                if (btnChat != null) {

                    btnChat.classList.remove('linkIsSelected-202');
                }
                document?.getElementById("div1")?.classList.remove('col-md-2');
                document?.getElementById("div1")?.classList.add('col-md-3');
                document?.getElementById("div1")?.classList.add('div1Padding');
                document?.getElementById("divCode")?.classList.remove('col-md-7');
                document?.getElementById("divCode")?.classList.add('col-md-9');
                document?.getElementById("divCode")?.classList.add('divCodePadding');
            }
        }
    }

    const toggleOptions = (selectedPane: string, setSelectedPane: (pane: string) => void): void => {
        if (selectedPane !== CommandPanelTypes.Settings) {
            ShowHideChat(CommandPanelTypes.Settings);
            if (closeButton != null)
                closeButton.style.display = "block";
        }
        else {
            if (closeButton != null)
                closeButton.style.display = "none";
        }

        return selectedPane !== CommandPanelTypes.Settings
            ? setSelectedPane(CommandPanelTypes.Settings)
            : setSelectedPane(CommandPanelTypes.None);
    };

    const toggleProblemStatement = (selectedPane: string, setSelectedPane: (pane: string) => void): void => {
        if (selectedPane !== CommandPanelTypes.ProblemStatement) {
            ShowHideChat(CommandPanelTypes.ProblemStatement);
            if (closeButton)
                closeButton.style.display = "block";
        }
        else {
            if (closeButton)
                closeButton.style.display = "none";
        }


        return selectedPane !== CommandPanelTypes.ProblemStatement
            ? setSelectedPane(CommandPanelTypes.ProblemStatement)
            : setSelectedPane(CommandPanelTypes.None);
    };

    const onChangeBlurEffect = async (): Promise<void> => {
        if (!isBlur) {
            await blurEffectStart();
            isBlur = true;
        }
        else {
            await blurEffectStop();
            isBlur = false;
        }
    }

    return (
        <Stack className={mediaControlStyles}>
            <CommandButton
                onKeyDownCapture={(e): void => {
                    if (e.keyCode === 13 && props.localVideoRendererIsBusy) {
                        e.preventDefault();
                    }
                }}
                disabled={cameraDisabled}
                onClick={cameraOnClick}
                className={controlButtonStyle}
                id="cameraIconId"
            >
                <div className={fullWidth}>
                    {cameraActive ? <CallVideoIcon size="medium" /> : <CallVideoOffIcon size="medium" />}
                </div>
            </CommandButton>
            <CommandButton onClick={micOnClick} disabled={micDisabled} className={controlButtonStyle} id="micIconId">
                <div className={fullWidth}>{micActive ? <MicIcon size="medium" /> : <MicOffIcon size="medium" />}</div>
            </CommandButton>
            {props.isLocalScreenShareSupportedInBrowser() && ScreenShareAllowed && (
                <CommandButton
                    disabled={screenShareDisabled}
                    onClick={props.onScreenShareChange}
                    className={screenShareDisabled ? controlButtonDisabledStyle : controlButtonStyle}
                >
                    <div className={fullWidth}>
                        {props.screenShareActive ? (
                            <CallControlCloseTrayIcon size="medium" />
                        ) : (
                            <CallControlPresentNewIcon size="medium" />
                        )}
                    </div>
                </CommandButton>
            )}
            <CommandButton onClick={async (): Promise<void> => { await onChangeBlurEffect(); } } className={controlButtonStyle} id="blurIconId">
                <div className={fullWidth}><UserBlurIcon size="medium" /> </div>
            </CommandButton>

            {props.screenWidth > Constants.MINI_HEADER_WINDOW_WIDTH && (
                <CommandButton
                    onClick={props.onEndCallClick}
                    className={props.compressedMode ? controlButtonStyle : endCallButtonStyle}
                >
                    <div className={fullWidth}>
                        <CallEndIcon size="medium" />
                        {!props.compressedMode &&
                            <span className={endCallButtonTextStyle}>
                                {getLeaveButtonName()}
                            </span>}
                    </div>
                </CommandButton>
            )}

            {props.screenWidth < Constants.MINI_HEADER_WINDOW_WIDTH && (
                <ButtonGroup
                    id="mobileViewMoreVert"
                    variant="contained"
                    aria-label="split button"
                    style={{
                        boxShadow: "none"
                    }}
                >
                    <Button
                        ref={anchorRef}
                        size="small"
                        aria-controls={open ? 'split-button-menu' : undefined}
                        aria-expanded={open ? 'true' : undefined}
                        aria-label="select merge strategy"
                        aria-haspopup="menu"
                        style={{ top: "6px", background: "none", color: "#605e5c", padding: "0px", minWidth: "20px" }}
                    >
                        <div className={fullWidth}>
                            <MoreVert onClick={handleToggle}></MoreVert>
                        </div>
                    </Button>

                </ButtonGroup>
            )}
            <Popper
                style={{
                    top: "40px",
                    zIndex: 1,
                    left: "30px"
                }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-end"
                transition
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    id="composition-menu"
                                    aria-labelledby="composition-button"
                                    style={{ paddingTop: "0px" }}
                                    autoFocusItem={open}
                                    onKeyDown={handleListKeyDown}
                                >
                                    <MenuItem
                                        style={{ padding: "0px 0px 0px 10px", minHeight: "30px" }}
                                        onClick={handleClose}
                                    >
                                        <CommandButton
                                            onClick={props.onEndCallClick}
                                            style={{ background: "transparent" }}
                                        >
                                            <div className={fullWidth}>
                                                <CallEndIcon size="medium" />
                                                <span style={{ paddingLeft: "10px" }}>{getLeaveButtonName()}</span>
                                            </div>
                                        </CommandButton>
                                    </MenuItem>

                                    <MenuItem
                                        style={{ padding: "0px 0px 0px 10px", minHeight: "30px" }}
                                        onClick={handleClose}
                                    >
                                        <CommandButton
                                            onClick={
                                                (): void => {
                                                    const miscIcon = document.getElementsByClassName("userStreamMicSection");
                                                    const userSection: HTMLDivElement | null = document.querySelector(".UserSection");
                                                    if (miscIcon != null) {
                                                        for (var i = 0; i < miscIcon.length; i++) {
                                                            var div = miscIcon[i] as HTMLDivElement;
                                                            div.style.display = "Block";

                                                            if (props.selectedPane != CommandPanelTypes.Settings) {
                                                                div.style.display = "none";
                                                            }
                                                            if (userSection != null) {
                                                                if (props.selectedPane == CommandPanelTypes.Settings)
                                                                    userSection.style.display = "block";
                                                            }
                                                        }
                                                    }
                                                    toggleOptions(props.selectedPane, props.setSelectedPane);
                                                }
                                            }
                                            style={{ background: "transparent", color: props.selectedPane === CommandPanelTypes.Settings ? "#0078d4" : "#605e5c" }}
                                        >
                                            <div className={fullWidth}>
                                                <SettingsIcon />
                                                <span style={{ paddingLeft: "10px" }}>Settings</span>
                                            </div>
                                        </CommandButton>
                                    </MenuItem>

                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </Stack>
    );
};
